module.exports = __webpack_public_path__ + "img/triangle-bottom.fee84e6f.png";